import { render, staticRenderFns } from "./OrderOptions.vue?vue&type=template&id=2f639d2e&scoped=true"
import script from "./OrderOptions.vue?vue&type=script&lang=js"
export * from "./OrderOptions.vue?vue&type=script&lang=js"
import style0 from "./OrderOptions.vue?vue&type=style&index=0&id=2f639d2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f639d2e",
  null
  
)

export default component.exports